
(function () {

    const postBackFilters = document.querySelectorAll('[data-postback-search]');

    let searchParams = new URLSearchParams(window.location.search);
    postBackFilters.forEach(f => {

        // Update The Value if in search
        if (searchParams.has(f.dataset.postbackSearch)) {
            f.value = searchParams.get(f.dataset.postbackSearch);
        }

        f.addEventListener("change", (e) => {
            searchParams.set(e.target.dataset.postbackSearch, e.target.value);
            let url  = url = window.location.protocol + "//" + window.location.host + window.location.pathname + "?" + searchParams.toString();
            window.location.replace(url);
        });
    })

    //
})()